<template>
    <Form
        :messenger-settings="messengerSettings"
        :errors="errors"
        @form-submitted="submitData"
    />
</template>

<script setup>
import Form from '~@/Components/Settings/MessengerSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    messengerSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const submitData = (form) => {
    form.post(route('settings.messenger-settings.store'))
}
</script>
